import { useContext } from 'react';
import { RegisterContext } from '@/features/login/registration';

export const useRegisterInfo = () => {
  const context = useContext(RegisterContext);
  return context;
};
